"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryHighVariationRule = void 0;
const zod_1 = require("zod");
const utils_1 = require("@azimutt/utils");
const databaseUtils_1 = require("../../databaseUtils");
const duration_1 = require("../../helpers/duration");
const sql_1 = require("../../helpers/sql");
const connector_1 = require("../../interfaces/connector");
const rule_1 = require("../rule");
const ruleId = 'query-high-variation';
const ruleName = 'query with high variation';
const ruleDescription = 'top 20 queries by execution time standard deviation when execution count is over the threshold';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: connector_1.QueryId.array().optional(),
    minExec: zod_1.z.number().optional(), // optional for retro-compatibility
}).strict().describe('QueryHighVariationConf');
exports.queryHighVariationRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.hint, minExec: 10 },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.extra?.queryId).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores || []);
        return queries
            .filter(q => !ignores.some(i => i === q.id))
            .filter(q => (q.exec?.count || 0) >= (conf.minExec || 0))
            .sort((a, b) => -((a.exec?.sdTime || 0) - (b.exec?.sdTime || 0)))
            .slice(0, 20)
            .map(q => {
            const entity = (0, sql_1.getMainEntity)(q.query);
            const sd = (0, duration_1.showDuration)(q.exec?.sdTime || 0);
            const min = (0, duration_1.showDuration)(q.exec?.minTime || 0);
            const max = (0, duration_1.showDuration)(q.exec?.maxTime || 0);
            const { id, database, query, ...stats } = q;
            return (0, utils_1.removeUndefined)({
                ruleId,
                ruleName,
                ruleLevel: conf.level,
                message: `Query ${q.id}${entity ? ` on ${(0, databaseUtils_1.entityRefToId)(entity)}` : ''} has high variation, with ${sd} standard deviation and exec time ranging from ${min} to ${max} (${(0, sql_1.formatSql)(q.query)})`,
                entity,
                extra: { queryId: id, query, stats, entities: (0, sql_1.getEntities)(q.query) }
            });
        });
    }
};
//# sourceMappingURL=queryHighVariation.js.map